@if (noItems$ | async) {
  @if (loading$ | async) {
    <p class="w-full text-center py-16"><em>Loading items...</em></p>
  } @else {
    @if (productType === 'hire') {
      <p class="w-full text-center py-16">
        <em
          >No items have been added to this product or category yet, please go
          to the product profile and add an item</em
        >
      </p>
    } @else {
      <p class="w-full text-center py-16">
        <em
          >There are no categoires to show here as your retail products have not
          been added to categories, search or scan a product instead.</em
        >
      </p>
    }
  }
} @else {
  <div
    class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-3"
  >
    @if (showParentButton$ | async) {
      <a
        [testId]="testIds.GRID_ITEM"
        (click)="goToParentCategory()"
        mat-ripple
        [matRippleCentered]="true"
        class="py-6 text-lg drop-shadow border basis-1/2 md:basis-1/5 min-h-32 flex flex-col items-center justify-center rounded-lg line-clamp-3 bg-white border-gray-200"
      >
        <div class="text-4xl">
          <mat-icon class="text-gray-500" [inline]="true"
            >chevron_left</mat-icon
          >
        </div>
        <p
          class="text-center md:px-1 lg:px-4 max-w-full line-clamp-3 break-words text-gray-500"
          [testId]="testIds.GRID_ITEM_LABEL"
        >
          Parent Catgegory
        </p>
      </a>
    }
    @for (item of items$ | async; track item.id) {
      <a
        [testId]="testIds.GRID_ITEM"
        (click)="selectItem(item)"
        mat-ripple
        [matRippleCentered]="true"
        class="py-6 text-lg drop-shadow border basis-1/2 md:basis-1/5 min-h-32 flex flex-col items-center justify-center rounded-lg line-clamp-3"
        [ngClass]="{
          'cursor-not-allowed bg-gray-100': item.enabled === false
        }"
        [style]="{ background: item.background, borderColor: item.outline }"
      >
        <p
          class="text-center md:px-1 lg:px-4 max-w-full line-clamp-3 break-words"
          [testId]="testIds.GRID_ITEM_LABEL"
          [style]="{ color: item.contrast }"
        >
          {{ item.label }}
        </p>
        <p
          *ngIf="item.enabled === false"
          [testId]="testIds.GRID_ITEM_SUB_LABEL"
        >
          <small>(Unavailable)</small>
        </p>
      </a>
    }
  </div>
}
